export default __webpack_public_path__ + "static/media/stage_00@2x.de59d650.png";